module.exports = __webpack_public_path__ + "img/Rust-4-mobile.19db4781.png";